// extracted by mini-css-extract-plugin
export default {"modal":"XL-z","modalOverlay":"YL-z","outfitHeading":"ZL-z"};